import HelpBestPractices from './components/HelpBestPractices';

export default HelpBestPractices;



// WEBPACK FOOTER //
// ./src/routes/HelpBestPractices/index.js